export default __webpack_public_path__ + "static/media/TheSustainableDevelopmentGoalsReport2022.66cec9fa.pdf";